import { Button, Icon, Loader } from "semantic-ui-react";

import { Can } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { classNames } from "utils/common";

import type { Question, QuestionID } from "models";

type QuestionsListProps = {
  title: string;
  questions: Question[];
  isLoading: boolean;
  onQuestionClick: (questionID: QuestionID) => void;
  onAdd?: () => void;
};

export const QuestionsList = ({ title, questions, isLoading, onQuestionClick, onAdd }: QuestionsListProps) => (
  <div className="QuestionsList">
    <div className="questions-header">
      {onAdd && (
        <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.Questions}>
          <Button className="-appointment-status icon" size="small" onClick={onAdd}>
            <Icon className="plus" />
          </Button>
        </Can>
      )}
      <h3>{title}</h3>
    </div>

    <div className="questions-container">
      {isLoading && <Loader active inline="centered" />}

      {!isLoading &&
        questions.map(question => (
          <div key={question.id} className={`question-item ${classNames({ "is-inactive": !question.active })}`} onClick={() => onQuestionClick(question.id)}>
            {question.title}
          </div>
        ))}
    </div>
  </div>
);
